import { Button } from "antd";
import { useIntl } from "react-intl";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { NotificationStatuses } from "~enums/notificationStatuses.ts";
import { NotificationItemBody } from "~pages/Notifications/components/NotificationItemBody.tsx";
import { useNotificationService } from "~pages/Notifications/hooks/useNotificationService.ts";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

export const ExportNotificationItem = ({ notification }: Props) => {
  const { formatMessage } = useIntl();
  const { markNotificationAsRead } = useNotificationService();
  const { refetch: refetchUserUpdates } = useUserUpdates();

  const downloadButton = (
    <Button
      type="primary"
      key="download"
      href={notification.data.DownloadUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
      onClick={() => {
        if (notification.unread) {
          void markNotificationAsRead(notification.key);
        }
        refetchUserUpdates();
      }}
    >
      {formatMessage({ id: "download" })}
    </Button>
  );

  const customButtons = notification.status === NotificationStatuses.Completed && notification?.data?.DownloadUrl ? [downloadButton] : [];

  return <NotificationItemBody notification={notification} icon="fa-file-export" customButtons={customButtons} />;
};
